'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

import { isMobile } from 'react-device-detect';

import { Icons } from 'app/constants/icons';

export const PortraitModeWatcher = ({children}: PropsWithChildren) => {
  const [portraitMode, setPortraitMode] = useState(false);

  useEffect(() => {
    if (!isMobile) {
      setPortraitMode(false);
      return;
    }

    const mediaQueryList = window.matchMedia('(orientation: landscape)');

    const listener = (event: MediaQueryListEvent) => {
      setPortraitMode(event.matches);
    };

    setPortraitMode(mediaQueryList.matches);

    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);

  if (portraitMode) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-10 px-4 py-10">
        <h3 className="text-center text-2xl font-normal text-neutral-100">
          Please rotate your device to portrait.
        </h3>

        <Icons.portrait className="text-neutral-100" width={60} />
      </div>
    );
  }

  return <>{children}</>;
};
